import React from 'react';
import ReactDOM from 'react-dom';
import lang from "ac-lang-cn";
import 'assets/style/reset.css';
import 'assets/style/animate.css';
import 'assets/style/iuapmobile.um.css';
import 'assets/style/base.css';

// 查看ac-lang源码 发现设置此变量
window.globalization = {
	locale: window.diworkContext ? window.diworkContext().locale : (window.getCurrentLangCode ? window.getCurrentLangCode() : "zh_CN"),
}
const langInit = require("../pack/pack");
lang.init(langInit);

window.name = "DIWORK_LOGIN";
window.React = React;
window.ReactDOM = ReactDOM;

/*热更新*/
if (module.hot) {
	module.hot.accept();
}
const App =  require("pages/index").default;
const rootElm = document.getElementById('root');
ReactDOM.render(<App />, rootElm);